const NewsletterMatchType = {
  STATIC: 'static',
  DYNAMIC: 'dynamic',
  FALLBACK: 'fallback',
};

export default NewsletterMatchType;
